module.exports = __webpack_public_path__ + "img/user-profile-right-cookies.c94017c3.webp";